import styled from 'styled-components';

const Title = styled.h3`
  margin-bottom: 10px;
`;

Title.displayName = 'Title';

export default Title;
